import React from 'react';

interface ModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 z-[999] transition-opacity duration-300 ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={onClose}
      />
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-8 border border-border z-[1000] max-w-[360px] text-center transition-all duration-300 ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="text-lg font-medium mb-4">{title}</div>
        <div className="text-sm text-secondary mb-6">{message}</div>
        <button
          className="px-6 py-3 bg-primary text-white border-0 cursor-pointer text-xs uppercase tracking-widest"
          onClick={onClose}
        >
          Compris
        </button>
      </div>
    </>
  );
};
